module.exports = __webpack_public_path__ + "img/mm-and.2dd3424d.png";